const codMeseroLabel = 'Código del mesero';
const nomMeseroLabel = 'Nombre del mesero';
const btnMeseroLabel = 'Registro del mesero';

export {codMeseroLabel, nomMeseroLabel, btnMeseroLabel};
